import { render, staticRenderFns } from "./DefaultSidebarLink.vue?vue&type=template&id=7fc94b38"
import script from "./DefaultSidebarLink.vue?vue&type=script&lang=ts"
export * from "./DefaultSidebarLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports